module.exports = __webpack_public_path__ + "media/images/web_suite/muscles_icon-f620af610c4b9390f75b5e294c2c16a3.png";